module.exports = __webpack_public_path__ + "static/img/DSC_2700.0eefaad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC_2700.jpg
// module id = 279
// module chunks = 0